import React from 'react';
import { Typo, Rhythm } from 'components/Layout';
import { Button } from 'components/Form';
import Icon from 'components/Icon';
import cx from 'classnames';

import styles from './styles.css';
import { useTranslation } from 'react-i18next';

export default ({ state, isLoading, hideModal }: any) => {
  const { t } = useTranslation('common');
  return (
    <div className={cx(styles.root, state.success && styles.success)}>
      {
        <Icon
          name={state.icon || 'error-outline'}
          className={styles.icon}
          width={40}
          height={40}
        />
      }
      {state.title && (
        <Typo.Title className={styles.title}>{state.title}</Typo.Title>
      )}
      {state.description && (
        <Typo.Paragraph className={styles.description}>
          {state.description}
        </Typo.Paragraph>
      )}
      <Rhythm center>
        <Button onClick={hideModal} type="secondary">
          {state.cancelText || t('general.cancel')}
        </Button>
        {state.onSubmit && (
          <Button onClick={state.onSubmit} isLoading={isLoading} type="warning">
            {state.submitText || t('general.delete')}
          </Button>
        )}
      </Rhythm>
    </div>
  );
};
